// extracted by mini-css-extract-plugin
module.exports = {"container":"e_zw","pending":"e_Aw","slider":"e_Bw","imageContainer":"e_Cw","image":"e_Dw","button":"e_Ew","prevButton":"e_Fw","nextButton":"e_Gw","disabled":"e_Hw"};